import { Business } from '@40seas/entities/businesses';
import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateBusinessDto extends Omit(Business, [...BaseEntityFieldsArray, 'slug'], ['slug']) {
    slug?: string;
}
